(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /*  This uses the angular ui-bootstrap "typeahead" directive option,
      "typeahead-editable='false'", which restricts ng-model values to ones actually
      selected from the popup list.  No other logic is needed to enforce that.
       However, it is desired that the input textbox not retain any values that do not
      correspond to selected items.  Because the "model value" is hidden in the UI, the
      text box is the only feedback that a valid value has been typed & selected.
       This directive uses a second value, "selectedVerb" to record the selected value
      and "verb" is used in logic to clear the textbox contents if they are invalid.
  */
  /*  REQUIRED ATTRIBUTES:
       inputId - allows the controller to provide the id of the input element created by the directive
      selectedVerb - the object that is populated when user selects from the typeahead list.  It must
          be preset to the existing item display when the selector is used to edit an existing item.
       OPTIONAL ATTRIBUTES:
       verbStatus - reference to the function that returns the bootstrap validation classes of
          'has-error', 'has-success', or null.  It can be used for visual validation feedback.
      clearVerb - reference to the directive function that clears both the textbox text and selectedVerb.
      clearButton - if specified, a clear button is added to the input text box when an verb is selected.
          To include the clear button, use the attribute 'clearButton = "true"'.
      isAssessment - boolean value to limit typeahead items to assessment activities; default = false.
      limit - a value that set the number of typeahead items displayed; default = 10.
      onVerbSelected - user provided function that can be used provide additional validation of selectedVerb.
          If supplied, onSelectVerb takes one parameter 'item' and returns true/false or a promise object that
          eventually returns true or false. Example: onVerbSelected = "validateVerb(item)".
      onClearButtonClick - user provided callback to allow clearing of errors when the clear button is clicked.
          Has no effect if clearButton is not true.  Example: onClearButtonClick = "clearErrors()".
      placeholder - string used as a placeholder in the input textbox; default: 'Search by verb display'
           To specify a placeholder, use the attribute placeholder="'your placeholder text'".
  */

  directive('wsVerbSelector', ['$http', '$q', 'Api', '$timeout', 'User', 'QuickFilters', function ($http, $q, Api, $timeout, User, QuickFilters) {
    return {
      scope: {
        inputId: "@",
        selectedVerb: "=",
        verbStatus: "=?",
        clearVerb: "=?",
        clearButton: "=?",
        limit: "=?",
        onVerbSelected: "&?",
        clearVerbOnSelect: "=?",
        onClearButtonClick: "&?",
        placeholder: "=?",
        hideId: "=?",
        isDemoMode: "=?",
        excludeVerbs: "<?",
        searchFilter: "=?",
        referenceType: "<",
        referenceId: "<"
      },
      templateUrl: "modules/common/directives/verb-selector/verb-selector.html",
      link: function link($scope, element, attrs) {
        $scope.limit = $scope.limit || 10;
        $scope.placeholder = $scope.placeholder || 'Search by verb name';
        if (!attrs.onVerbSelected) {
          $scope.onVerbSelected = function () {
            return true;
          };
        }
        if (!attrs.onClearButtonClick) {
          $scope.onClearButtonClick = angular.noop;
        }
        $scope.isDemoMode = $scope.isDemoMode || function () {
          return false;
        };

        //  - hasFocus ensures that verbStatus() reflects validity only when typeahead has focus
        //  - isValid reflects the validity of the current selected value (if any)
        var hasFocus = false;
        var isValid = null;
        var noMatchError = "No matching verbs";

        // if selectedVerb fields = "", convert to null
        if (angular.equals($scope.selectedVerb, {
          verbId: "",
          name: ""
        })) {
          $scope.selectedVerb = null;
        }
        $scope.verbStatus = function () {
          if (hasFocus && isValid !== null) {
            return isValid ? "has-success" : "has-error";
          }
          return "";
        };
        $scope.clearVerb = function () {
          delete $scope.selectedVerb;
          $scope.verb = null;
          $scope.errorMsg = null;
          isValid = null;
          $scope.verbTypeahead("");
        };
        function setVerbFocus() {
          $("#" + $scope.inputId).focus();
        }
        $scope.clearVerbClick = function () {
          if ($scope.clearVerb !== undefined) {
            $scope.clearVerb();
          }
          $scope.onClearButtonClick();
          $timeout(setVerbFocus, 0); // use timeout to set focus on next $apply() cycle
        };

        // watch $scope.verb to catch clearing of input field by deleting its text
        $scope.$watch('verb', function listener(newValue) {
          if (newValue === "") {
            $scope.clearVerbClick();
          }
        });
        $scope.verbSelected = function (item) {
          $scope.selectedVerb = item;
          if ($scope.clearVerbOnSelect) {
            $scope.verb = '';
          }

          // call user-provided validation function, a promise
          // var validate = $scope.onVerbSelected({item: item});
          $q.when($scope.onVerbSelected({
            item: item
          })).then(function (result) {
            isValid = result;
          });
        };

        // Enforce that we'll only allow a value to remain in the input field that's
        // actually been selected from the list. "verb" will be undefined
        // or "" if the input text is invalid.
        $scope.verbBlur = function () {
          hasFocus = false; // prevents "late" key events from affecting status
          if ($scope.verb === undefined || $scope.verb === "") {
            if ($scope.clearVerb !== undefined) {
              $scope.clearVerb();
            }
          }
        };
        $scope.verbFocus = function () {
          hasFocus = true;
        };
        $scope.verbTypeahead = function (query) {
          //don't run this logic if org hasn't been selected
          var session = User.get();
          if (session.organization === undefined) {
            return;
          }
          if (!query || !query.length) {
            return;
          }
          if (hasFocus) {
            // indicate "invalid" while typing in input field
            isValid = false;
            delete $scope.selectedVerb;
          }
          var sortParam = QuickFilters.getQuickFilterSortParam($scope.referenceType, $scope.referenceId, {
            itemName: 'verbs'
          }, "verbId");

          /*jshint camelcase: false */
          var searchParams = {
            searchTerm: query,
            order_by: sortParam,
            _limit: $scope.limit,
            demo: $scope.isDemoMode()
          };
          /*jshint camelcase: true */

          if ($scope.searchFilter) {
            _.extend(searchParams, $scope.searchFilter);
          }
          if ($scope.referenceType) {
            searchParams[$scope.referenceType] = $scope.referenceId;
          }
          var excludeVerbs = _.flatten($scope.excludeVerbs);
          if (excludeVerbs && excludeVerbs.length) {
            if (typeof excludeVerbs[0] === 'string') {
              searchParams.exclude = excludeVerbs;
            } else {
              searchParams.exclude = _.pluck(excludeVerbs, 'verbId');
            }
          }

          // This endpoint search within name, description and verbId
          return $http.get(Api.url('/acc/verbs/search'), {
            params: searchParams
          }).then(function verbSearchSuccess(response) {
            if (response.data.results.length > 0) {
              $scope.errorMsg = null;
              var res = response.data.results;
              var results = _.map(res, function (result) {
                return {
                  verbId: result.verbId,
                  name: result.display,
                  display: result.display,
                  description: result.description,
                  isAssessment: result.assessment
                };
              }).slice(0, $scope.limit);
              return results;
            }

            // default - no matching items found
            isValid = false;
            $scope.errorMsg = noMatchError;
            return [];
          });
        };

        // set initial view of selector textbox & check for results/validity
        $scope.verb = $scope.selectedVerb ? $scope.selectedVerb.display : "";
        $scope.verbTypeahead($scope.selectedVerb ? $scope.selectedVerb.verbId : "");
      }
    };
  }]);
})();
